// Breadcrumb identifiers
const userBreadcrumbIdentifier = {
    route: 'users.edit',
    parameterLabel: 'user',
    parameters: ['user']
}
const roleBreadcrumbIdentifier = {
    route: 'settings.roles.edit',
    parameterLabel: 'role',
    parameters: ['role']
}

export default [
    {
        route: 'users.index',
        label: 'messages.sitemap.users.users',
        showInSidebar: true,
        permissions: ['user.view', 'user.create'],
        id: 'users-index',
        children: [
            {
                route: 'users.edit',
                label: 'messages.sitemap.users.edit',
                identifier: userBreadcrumbIdentifier
            }
        ]
    },
    {
        route: 'settings.roles.index',
        label: 'messages.sitemap.settings.roles.roles',
        showInSidebar: true,
        permissions: ['role.view'],
        id: 'users-roles-index',
        children: [
            {
                route: 'settings.roles.create',
                label: 'messages.sitemap.settings.roles.create'
            },
            {
                route: 'settings.roles.edit',
                label: 'messages.sitemap.settings.roles.edit',
                identifier: roleBreadcrumbIdentifier
            }

        ]
    }
]
